import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Alert": Alert, "@mui/icons-material/Check": CheckIcon } } });
export default ClientProvider;
